import { Container, Card, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";

export  function ThankYouPage() {
  const navigate = useNavigate();

  return (
    <Container className="mt-5 pb-5">
      <Card className="p-4 shadow mx-auto text-center" style={{ maxWidth: "600px" }}>
        <h2 className="mb-4">🎉 Thank You!</h2>
        <p className="lead">Your graduation cake order has been received successfully. We’ll be in touch soon with the next steps!</p>
        <p className="text-muted">You’ll receive a confirmation email shortly.</p>
        <Button 
          onClick={() => navigate("/")} 
          style={{ backgroundColor: "#ff5fa2", borderColor: "#ff5fa2" }}
          className="mt-3"
        >
          Back to Home
        </Button>
      </Card>
    </Container>
  );
}